import {
	closestOptional,
	closestRequired,
	getAttributeOrThrow,
} from '@/scripts/core/global'
import { type CartItems } from '@/scripts/cart/cart-items'
import { type CartDrawerItems } from '@/scripts/cart/cart-drawer-items'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class CartRemoveButton extends UcoastEl {
	static htmlSelector = 'cart-remove-button'
	constructor() {
		super()

		this.addEventListener('click', (event) => {
			event.preventDefault()

			// Optimistic removal — add CSS class for fade+collapse animation
			const row = this.closest('[data-uc-cart-item]')
			if (row) row.classList.add('cart-line--removing')

			const cartItems =
				closestOptional<CartItems>(this, 'cart-items') ||
				closestRequired<CartDrawerItems>(this, 'cart-drawer-items')
			const lineItemKey = this.getAttribute('data-line-item-key') ?? undefined
			cartItems.updateQuantity(
				getAttributeOrThrow('data-index', this),
				'0',
				undefined,
				lineItemKey
			)
		})
	}
}
